import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Text from "@components/Text";
import Stepper from "@components/_Revamp/Stepper";
import ReviewMessageBox from "./components/ReviewMessageBox";
import Accordion from "@pages/CCP/components/Accordion";
import Listing from "@pages/CCP/components/Listing";
import Button from "@components/_Revamp/Button";
import { useAvivaSelector } from "@redux/hook";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import { Helpers, formatDate } from "@utils/helpers";
import Modal from "@components/_Revamp/Modal";
import EditModal from "./components/EditModal";
import { Step } from "@components/_Revamp/Stepper/Stepper";
import BottomSheet from "@components/_Revamp/BottomSheet";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import { ROUTE_PATH } from "@static/route-paths";
import { Nationalities } from "@static/nationalities";
import { SCREEN_SIZE } from "@static/screen-size";
import { useScreenSize } from "@pages/CCP/Hooks/useScreenSize";
import { themeDefault } from "src/theme-revamp";
import { trackOnCTA, trackOnLoad } from "@pages/CCP/Helpers/analyticsHelper";
import { AA } from "@utils/adobeAnalyticsSS";
import {
  CCPAcquisitionDataLayerObject,
  CCPDataLayer,
} from "@pages/CCP/DataLayer/Datalayer.model";
import { CCP_STEP_LIST } from "@static/content";
import { ContainerWithStepper } from "@pages/CCP/components/ContainerWithStepper";
import {
  NotificationBox,
  NotificationContent,
} from "@components/_Revamp/NotificationBox";
import close from "@assets/icon/close-red.svg";
import {
  ErrorMessageBox,
  MessageContent,
} from "@components/_Revamp/ErrorMessageBox";
import { useDispatch } from "react-redux";
import { updatePaymentData } from "@redux/slices/CCP/step6Slice";

export interface ReviewProps {}
interface IItem {
  text?: string;
  value: string;
}

export interface EditBtnProps {
  onClick?: (e: any) => void;
}
const AAAgentMap: Record<string, string> = {
  "no-adviser": "No, I do not need an adviser",
  "singlife-adviser": "Yes, assign an adviser to me",
  "own-adviser": "Yes, I want to assign my own adviser",
};

const Review = () => {
  //TODO : Get previous data from step 1 to 4;

  const cancerCoverStep1 = useAvivaSelector((state) => state.cancerCoverStep1);
  const cancerCoverStep3 = useAvivaSelector((state) => state.cancerCoverStep3);
  const cancerCoverStep4 = useAvivaSelector((state) => state.cancerCoverStep4);
  const cancerCoverStep6 = useAvivaSelector((state) => state.cancerCoverStep6);

  const history = useHistory();

  const [personalDetails, setPersonalDetails] = useState<IItem[]>([]);
  const [planDetails, setPlanDetails] = useState<IItem[]>([]);
  const [mailingAddress, setMailingAddress] = useState<IItem[]>([]);
  const [farDetails, setFarDetails] = useState<IItem[]>([]);
  const [healthDetails, setHealthDetails] = useState<IItem[]>([]);
  const [childDetails, setChildDetails] = useState<IItem[]>([]);

  const [editModalVisible, setEditModalVisible] = useState<boolean>(false);
  const [editModalData, setEditModalData] = useState<any>(null);
  const { isMobile } = useScreenSize();
  const [isPaymentError, setIsPaymentError] = useState<boolean>();
  const dispatch = useDispatch();

  const campaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const paramCC = campaignDetail?.campaignCode
    ? `?cc=${campaignDetail.campaignCode}`
    : "";
  const analyticUrlParams = useAvivaSelector(
    (state) => state.urlAnalytic.param
  );
  const analyticParam = Helpers.getUrlAnalyticParams(
    paramCC !== "",
    analyticUrlParams
  );
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const isAdviserStepEmpty = useAvivaSelector(
    (state) => state.everGreenStep3.financialAdviser.autoAssignAgent
  );
  const isCampaignCode = useAvivaSelector(
    (state) => state.loading.campaignDetail?.product === "CANCERCOVERPLUS"
  );
  const adviser = useAvivaSelector(
      (state) => state.cancerCoverStep6.financialAdviser.adviserData
    );
  const isPromoCodeValid = 'validPromoCode' in adviser &&  adviser?.validPromoCode === "Y";
  const EditComponent = ({ onClick }: EditBtnProps) => {
    return <EditBtnParagraph onClick={onClick}>Edit</EditBtnParagraph>;
  };

  const args = useMemo(() => {
    return {
      theme: themeDefault,
      className: container_with_bg_css,
      title: "Personal Information",
      titleClassName: title_with_bg_css,
      titleColor: themeDefault.colors.grey[500],
      titleFontSize: isMobile ? 18 : 20,
      showHeaderBackground: true,
      contentMarginLeft: "0",
      contentMarginRight: "0",
      showBottomLine: false,
      bottomLineColor: "#000",
      showExtraElement: true,
    };
  }, [isMobile]);

  const listingArg = useMemo(() => {
    return {
      headingFontSize: "14px",
      summaryTextFontSize: "14px",
      summaryValueFontSize: "14px",
      listingHeadingFontSize: "14px",
      headerMaxValueWidth: isMobile ? "120px" : "333px",
    };
  }, [isMobile]);

  const displayModal = (e: any, path: string, pageTitle: string) => {
    e.stopPropagation();
    setEditModalVisible(true);
    let obj = {
      title: pageTitle,
      onBackClick: () => {
        setEditModalVisible(false);
      },
      onProceedClick: () => {
        history.push(path + paramCC + analyticParam);
        setEditModalVisible(true);
      },
    };
    setEditModalData(obj);
  };

  useEffect(() => {
    if (isEmpty(cancerCoverStep4.myInfo)) {
      history.push(ROUTE_PATH.CANCER_COVER_LANDING_PAGE);
      return;
    } else {
      setPlanDetails([
        {
          value: "Singlife Cancer Cover Plus II",
        },
        {
          value: "Yearly Renewable",
        },
        {
          value: `${
            cancerCoverStep1?.basicInfo?.paymentOption === "AP"
              ? "Yearly"
              : "Monthly"
          } Renewable`,
        },
        {
          value:
            "-" + "S$" + 
            Helpers.toCurrency(
              cancerCoverStep1?.quotation?.premiumDiscount || 0
            ),
        },
        {
          value: "S$" + Helpers.toCurrency(
            cancerCoverStep1?.quotation?.totalPremium || 0
          ),
        },
      ]);
      setPersonalDetails([
        { value: cancerCoverStep4.myInfo.fullName || "" },
        { value: cancerCoverStep4.myInfo.salutation || "" },
        { value: cancerCoverStep4.myInfo.firstName || "" },
        { value: cancerCoverStep4.myInfo.lastName || "" },
        {
          value: cancerCoverStep4.myInfo.mobileNum
            ? "+65 " +
              cancerCoverStep4.myInfo.mobileNum?.substring(0, 4) +
              " " +
              cancerCoverStep4.myInfo.mobileNum?.substring(4, 8)
            : "",
        },
        { value: cancerCoverStep4.myInfo.emailId || "" },
        {
          value: cancerCoverStep4.myInfo.dateOfBirth
            ? formatDate(cancerCoverStep4.myInfo.dateOfBirth)
            : "",
        },
        { value: cancerCoverStep4.myInfo.nric || "" },
        { value: cancerCoverStep4.myInfo.nationality || "" },
        { value: cancerCoverStep4.myInfo.residentialStatus || "" },
        { value: cancerCoverStep4.myInfo.gender || "" },
        { value: cancerCoverStep4.myInfo.address.postal },
        { value: cancerCoverStep4.myInfo.address.unitNo },
        { value: cancerCoverStep4.myInfo.address.street },
        { value: cancerCoverStep4.myInfo.address.block },
        { value: cancerCoverStep4.myInfo.address.building },
      ]);
      setChildDetails([
        { value: cancerCoverStep4.selectedChildInfo?.fullName || "" },
        { value: cancerCoverStep4.selectedChildInfo?.salutation || "" },
        { value: cancerCoverStep4.selectedChildInfo?.firstName || "" },
        { value: cancerCoverStep4.selectedChildInfo?.lastName || "" },
        {
          value: cancerCoverStep4.selectedChildInfo?.dateOfBirth
            ? formatDate(cancerCoverStep4.selectedChildInfo?.dateOfBirth)
            : "",
        },
        { value: cancerCoverStep4.selectedChildInfo?.nric || "" },
        { value: cancerCoverStep4.selectedChildInfo?.gender || "" },
      ]);
      setHealthDetails([
        {
          value:
            cancerCoverStep3.underWriting1.isMedication === "YES"
              ? "Yes"
              : "No",
        },
        {
          value:
            cancerCoverStep3.underWriting1.isBenignGrowths === "YES"
              ? "Yes"
              : "No",
        },
        {
          value:
            cancerCoverStep3.underWriting1.isTreatment === "YES" ? "Yes" : "No",
        },
        {
          value:
            cancerCoverStep3.underWriting1.isRecurrence === "YES"
              ? "Yes"
              : "No",
        },
        {
          value:
            cancerCoverStep3.underWriting1.isBreastGrowths === "YES"
              ? "Yes"
              : "No",
        },
        {
          value:
            cancerCoverStep3.underWriting1.isColonPolyps === "YES"
              ? "Yes"
              : "No",
        },
        {
          value:
            cancerCoverStep3.underWriting1.isOtherBenignGrowths === "YES"
              ? "Yes"
              : "No",
        },
        {
          value:
            cancerCoverStep3.underWriting2.doneScreening === "YES"
              ? "Yes"
              : "No",
        },
        {
          value:
            cancerCoverStep3.underWriting2.doneScreening === "YES"
              ? cancerCoverStep3.underWriting2.result === "NORMAL"
                ? "Normal"
                : cancerCoverStep3.underWriting2.result === "AWAITING"
                ? "Awaiting results"
                : "Abnormal or requiring monitoring"
              : "-",
        },
        {
          value:
            cancerCoverStep3.underWriting1.isMedication === "YES"
              ? "Yes"
              : "No",
        },
      ]);
      setMailingAddress([
        {
          value:
            Nationalities.find(
              (country) =>
                country.code ===
                (cancerCoverStep4.myInfo.mailingAddress?.country ||
                  cancerCoverStep4.myInfo.address.country)
            )?.description || "",
        },
        {
          value:
            cancerCoverStep4.myInfo.mailingAddress?.postal ||
            cancerCoverStep4.myInfo.address.postal ||
            "",
        },
        {
          value:
            cancerCoverStep4.myInfo.mailingAddress?.unitNo ||
            cancerCoverStep4.myInfo.address.unitNo ||
            "",
        },
        {
          value:
            cancerCoverStep4.myInfo.mailingAddress?.street ||
            cancerCoverStep4.myInfo.address.street ||
            "",
        },
        {
          value:
            cancerCoverStep4.myInfo.mailingAddress?.block ||
            cancerCoverStep4.myInfo.address.block ||
            "",
        },
        {
          value:
            cancerCoverStep4.myInfo.mailingAddress?.building ||
            cancerCoverStep4.myInfo.address.building ||
            "",
        },
      ]);
      setFarDetails([
        {
          value:
            cancerCoverStep6.financialAdviser?.autoAssignAgent ===
            "singlife-adviser"
              ? "Yes, assign an adviser to me"
              : cancerCoverStep6.financialAdviser?.autoAssignAgent ===
                "no-adviser"
              ? "No, I do not need an adviser"
              : "Yes, I want to assign my own adviser",
        },
        {
          value:
            cancerCoverStep6.financialAdviser?.autoAssignAgent === "own-adviser"
              ? cancerCoverStep6.FARData?.code || ""
              : "",
        },
        {
          value:
            cancerCoverStep6.financialAdviser?.autoAssignAgent === "own-adviser"
              ? cancerCoverStep6.financialAdviser?.adviserData?.data
                  ?.fullName ||
                cancerCoverStep6.FARData?.name ||
                ""
              : "",
        },
      ]);
    }
  }, [
    cancerCoverStep1,
    cancerCoverStep4,
    cancerCoverStep6,
    cancerCoverStep3,
    history,
  ]);

  useEffect(() => {
    if (!isLoaded) {
      setIsLoaded(true);
    }
  }, [isLoaded]);

  useEffect(() => {
    const aadata = AA.getInstance().digitalData as CCPDataLayer;
    trackOnLoad({
      acquisitionUpdated: {
        ...aadata.acquisition,
        customer: {
          ...aadata.acquisition.customer,
          servicingMode:
            AAAgentMap[cancerCoverStep6.financialAdviser.autoAssignAgent] || "",
        },
      },
    });
  }, []);

  const planSummarySources = [
    {
      heading: {
        text: "Plan",
        value: `${planDetails[0]?.value ? planDetails[0]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Policy Term",
        value: `${planDetails[1]?.value ? planDetails[1]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Premium Term",
        value: `${planDetails[2]?.value ? planDetails[2]?.value : "-"}`,
      },
    },
    cancerCoverStep1?.basicInfo?.promoCode
      ? {
        heading: {

          text: `Promo Code ${!isPromoCodeValid
              ? ` (${cancerCoverStep1.basicInfo.promoCode.toUpperCase()})`
              : ""
            }`,
            value: `${planDetails[3]?.value ? planDetails[3]?.value : "-"}`,
          },
        }
      : undefined,
    {
      heading: {
        text: `${
          cancerCoverStep1?.basicInfo?.paymentOption === "AP"
            ? "Annual"
            : "Monthly"
        } Premium with GST`,
        value: `${planDetails[4]?.value ? planDetails[4]?.value : "-"}`,
      },
    },
  ].filter((v) => v !== undefined);
  const personalInformationSources = [
    {
      heading: {
        text: "Full Name (as per NRIC)",
        value: `${personalDetails[0]?.value ? personalDetails[0]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Salutation",
        value: `${personalDetails[1]?.value ? personalDetails[1]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "First Name/Given Name",
        value: `${personalDetails[2]?.value ? personalDetails[2]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Last Name/Family Name",
        value: `${personalDetails[3]?.value ? personalDetails[3]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Mobile Number",
        value: `${personalDetails[4]?.value ? personalDetails[4]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Email",
        value: `${personalDetails[5]?.value ? personalDetails[5]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Date of Birth",
        value: `${personalDetails[6]?.value ? personalDetails[6]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "NRIC/FIN",
        value: `${personalDetails[7]?.value ? personalDetails[7]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Nationality",
        value: `${personalDetails[8]?.value ? personalDetails[8]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Residental Status",
        value: `${personalDetails[9]?.value ? personalDetails[9]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Gender",
        value: `${
          personalDetails[10]?.value ? personalDetails[10]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Residental Postal Code",
        value: `${
          personalDetails[11]?.value ? personalDetails[11]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Residental Unit (If any)",
        value: `${
          personalDetails[12]?.value ? personalDetails[12]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Residental Street Name",
        value: `${
          personalDetails[13]?.value ? personalDetails[13]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Residental Block",
        value: `${
          personalDetails[14]?.value ? personalDetails[14]?.value : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Residental Building Name (If any)",
        value: `${
          personalDetails[15]?.value ? personalDetails[15]?.value : "-"
        }`,
      },
    },
  ];

  const childInformationSources = [
    {
      heading: {
        text: "Full Name (as per NRIC)",
        value: `${childDetails[0]?.value ? childDetails[0]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Salutation",
        value: `${childDetails[1]?.value ? childDetails[1]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "First Name/Given Name",
        value: `${childDetails[2]?.value ? childDetails[2]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Last Name/Family Name",
        value: `${childDetails[3]?.value ? childDetails[3]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Date of Birth",
        value: `${childDetails[4]?.value ? childDetails[4]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "NRIC/FIN",
        value: `${childDetails[5]?.value ? childDetails[5]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Gender",
        value: `${childDetails[6]?.value ? childDetails[6]?.value : "-"}`,
      },
    },
  ];

  const mailingAddressResources = useMemo(() => {
    const arr = [
      {
        heading: {
          text: "Postal Code",
          value: `${mailingAddress[1]?.value ? mailingAddress[1]?.value : "-"}`,
        },
      },
      {
        heading: {
          text: "Unit (If any)",
          value: `${mailingAddress[2]?.value ? mailingAddress[2]?.value : "-"}`,
        },
      },
      {
        heading: {
          text: "Street Name",
          value: `${mailingAddress[3]?.value ? mailingAddress[3]?.value : "-"}`,
        },
      },
      {
        heading: {
          text: "Block",
          value: `${mailingAddress[4]?.value ? mailingAddress[4]?.value : "-"}`,
        },
      },
      {
        heading: {
          text: "Building Name (If any)",
          value: `${mailingAddress[5]?.value ? mailingAddress[5]?.value : "-"}`,
        },
      },
    ];
    if (
      cancerCoverStep4.myInfo?.mailingAddress?.country &&
      cancerCoverStep4.myInfo?.mailingAddress?.country !== "SG"
    ) {
      arr.unshift({
        heading: {
          text: "Country",
          value: `${mailingAddress[0]?.value ? mailingAddress[0]?.value : "-"}`,
        },
      });
    }
    return arr;
  }, [cancerCoverStep4.myInfo?.mailingAddress?.country, mailingAddress]);

  const healthDeclarationSources = [
    {
      heading: {
        text: "Have you ever had, or are you currently under investigation for:",
        value: healthDetails?.[0]?.value || "-",
      },
      descriptions: [
        {
          text: "Cancer, Carcinoma in situ of any kind, Hepatitis B (other than healthy carriers*), Hepatitis C, Cirrhosis, Liver disease due to alcohol, Crohn’s disease, Ulcerative Colitis, Barrett’s Oesophagus, HIV/AIDS",
        },
      ],
    },
    {
      heading: {
        text: "Have you had any benign growth?",
        value: healthDetails?.[1]?.value || "-",
      },
    },
    {
      heading: {
        text: "Have you had the following but was advised no treatment nor referral to specialist is needed?",
        value: healthDetails?.[2]?.value || "-",
      },
      descriptions: [
        {
          text: "Adenomyosis, Cervical cyst, Chalazion, Dermoid cyst, Endometriosis, Keratinous cyst, Nabothian cyst, Sebaceous cyst, Spinal synovial cyst",
        },
      ],
    },
    {
      heading: {
        text: "Have you had the following but was removed with no recurrence and no further follow-up needed?",
        value: healthDetails?.[3]?.value || "-",
      },
      descriptions: [
        {
          text: "Simple breast cyst, Congenital brain cyst (arachnoid/colloid), Endometrial polyp, Gallbladder polyp, Hemangioma, Lipoma, Ovarian cyst, Pilonidal cyst, Rhabdomyoma, Uterine fibroid",
        },
      ],
    },
    {
      heading: {
        text: "You’ve had breast growth such as:",
        value: healthDetails?.[4]?.value || "-",
      },
      descriptions: [
        {
          text: "Fibroadenoma, Fibrocystic breast disease",
        },
      ],
    },
    {
      heading: {
        text: "You’ve had colon polyp",
        value: healthDetails?.[5]?.value || "-",
      },
    },
    {
      heading: {
        text: "You have other benign growth other than the above",
        value: healthDetails?.[6]?.value || "-",
      },
    },
    {
      heading: {
        text: "Have you been advised (other than routine screening by age, where results are normal) or intend to undergo any of the following:",
        value: healthDetails?.[7]?.value || "-",
      },
      descriptions: [
        {
          text: "Biopsy, Tumour markers, Endoscopy, Colonoscopy, Ultrasound, CT/MRI/PET Scan, Mammography, Pap smear",
        },
      ],
    },
    {
      heading: {
        text: "What were the results?",
        value: healthDetails?.[8]?.value || "-",
      },
    },
    {
      heading: {
        text: "Did you have any of these symptoms in the last 6 months?",
        value: healthDetails?.[9]?.value || "-",
      },
      descriptions: [
        {
          text: "a) Weight loss of 5 kgs or more without diet or lifestyle modification; or",
          bulletVariant: "nobullet",
        },
        {
          text: "b) Coughing with blood; or ",
          bulletVariant: "nobullet",
        },
        {
          text: "c) Unusual bleeding or discharge from any body part for more than one week continuously; or ",
          bulletVariant: "nobullet",
        },
        {
          text: "d) Persistent change in bowel or bladder habits; or ",
          bulletVariant: "nobullet",
        },
        {
          text: "e) A mole or skin blemish which has changed in appearance",
          bulletVariant: "nobullet",
        },
      ],
    },
  ];

  const farResources = [
    {
      heading: {
        text: "Do you need a Financial Adviser Representative to service this policy?",
        value: `${farDetails[0]?.value ? farDetails[0]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Financial Adviser Representative Code",
        value: `${farDetails[1]?.value ? farDetails[1]?.value : "-"}`,
      },
    },
    {
      heading: {
        text: "Name of Adviser",
        value: `${farDetails[2]?.value ? farDetails[2]?.value : "-"}`,
      },
    },
  ];

  //AA on load
  useEffect(() => {
    if (!isAdviserStepEmpty) return;
  }, []);

  useEffect(() => {
    const status = cancerCoverStep6?.payment?.status;
    if (status === "unsuccessful") {
      setIsPaymentError(true);
      dispatch(updatePaymentData({ status: undefined }));
    }
  }, []);

  return (
    <>
      <ContainerWithStepper
        currentStep={ROUTE_PATH.CANCER_COVER_REVIEW}
        backButtonPath={ROUTE_PATH.CANCER_COVER_FINANCIAL_ADVISER}
      >
        <FormContainer>
          <FormHeaderContainer>
            <FormHeaderTitleContainer marginHorizontal={"0"}>
              <Text
                align={"center"}
                theme={themeDefault}
                className={HeaderTitleCss}
              >
                Review your application
              </Text>
            </FormHeaderTitleContainer>
            <FormHeaderDescriptionContainer>
              <Text theme={themeDefault} className={HeaderDescriptionCss}>
                Almost there! Check that all information is correct before
                making payment.
              </Text>
            </FormHeaderDescriptionContainer>
          </FormHeaderContainer>
        </FormContainer>

        <FormContentContainer>
          <ReviewMessageBox rowGap={"8px"}>
            <Text theme={themeDefault} className={MessageBoxParagraphCss}>
              <b>Note:</b> Pursuant to Section 23(5) of the Insurance Act 1966,
              you are required to disclose in this application form fully and
              faithfully all facts which you know or ought to know. Otherwise
              the insurance effected may be void.
            </Text>
          </ReviewMessageBox>
          <React.Fragment>
            <Accordion
              isExpanded={true}
              {...args}
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.CANCER_COVER_BASIC_INFO,
                      "Plan summary"
                    );
                  }}
                />
              }
              title="Plan Summary"
            >
              <Listing
                {...listingArg}
                sources={planSummarySources as any[]}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
            <Accordion
              isExpanded={false}
              {...args}
              title="Personal Information"
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    const isManual =
                      cancerCoverStep4.singpassInitiatedOrManual === "MANUAL";
                    const redirectUrl = isManual
                      ? ROUTE_PATH.CANCER_COVER_MY_INFO +
                        `?transaction_id=${cancerCoverStep4.myinfoTransactionId}&manual_data=available`
                      : ROUTE_PATH.CANCER_COVER_MY_INFO +
                        `?transaction_id=${cancerCoverStep4.myinfoTransactionId}`;
                    displayModal(e, redirectUrl, "My info");
                  }}
                />
              }
            >
              <Listing
                {...listingArg}
                sources={personalInformationSources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
                maxHeight="null"
              />
            </Accordion>
            {cancerCoverStep1?.basicInfo?.forwhom === "child" ? (
              <Accordion
                isExpanded={false}
                {...args}
                title="Child Information"
                extraElement={
                  <EditComponent
                    onClick={(e) => {
                      displayModal(
                        e,
                        ROUTE_PATH.CANCER_COVER_MY_INFO +
                          `?transaction_id=${cancerCoverStep4.myinfoTransactionId}`,
                        "My info"
                      );
                    }}
                  />
                }
              >
                <Listing
                  {...listingArg}
                  sources={childInformationSources}
                  variant="alternate"
                  underlineColor="#F5F5F5"
                  margin=""
                  maxHeight="null"
                />
              </Accordion>
            ) : null}
            <Accordion
              isExpanded={false}
              {...args}
              title="Mailing Address"
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.CANCER_COVER_MAILING_ADDRESS,
                      "Mailing Address"
                    );
                  }}
                />
              }
            >
              <Listing
                {...listingArg}
                sources={mailingAddressResources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
            <Accordion
              isExpanded={false}
              {...args}
              title="Health Declaration"
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.CANCER_COVER_UW_1A,
                      "Health Declaration"
                    );
                  }}
                />
              }
            >
              <Listing
                {...listingArg}
                sources={healthDeclarationSources as any[]}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
            <Accordion
              isExpanded={false}
              {...args}
              title="Financial Adviser Representative"
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.CANCER_COVER_FINANCIAL_ADVISER,
                      "Financial Adviser Representative"
                    );
                  }}
                />
              }
            >
              <Listing
                {...listingArg}
                sources={farResources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
          </React.Fragment>
        </FormContentContainer>

        <FormButtonContainer>
          <Button
            onClick={() => {
              history.push(ROUTE_PATH.CANCER_COVER_PAYMENT);
              trackOnCTA({
                ctaText: "Proceed to payment",
                ctaType: "qb:link",
              });
            }}
            width={"360px"}
            variant={"default"}
            theme={themeDefault}
            label={"Proceed to payment"}
          ></Button>
        </FormButtonContainer>
        <BottomSheet />
      </ContainerWithStepper>
      {editModalVisible && (
        <Modal className={modalPadding} show={editModalVisible}>
          <EditModal data={editModalData}></EditModal>
        </Modal>
      )}
      {isPaymentError ? (
        <div className={notificationContainer}>
          <ErrorMessageBox>
            <MessageContent>
              <div className={notificationClass}>
                <div>
                  <b>Payment Unsuccessful.</b> We have encountered an issue with
                  the payment method, please try again.
                </div>
                <CloseIcon
                  src={close}
                  onClick={() => setIsPaymentError(false)}
                  color="#c50000"
                />
              </div>
            </MessageContent>
          </ErrorMessageBox>
        </div>
      ) : null}
    </>
  );
};

export default Review;
const notificationContainer = css`
  position: fixed;
  bottom: 18px;
  right: 18px;
`;

const notificationClass = css`
  display: flex;
  width: unset;
  bottom: 24px;
  right: 24px;
  z-index: 5;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  text-align: left;
  color: #c50000;
  b {
    display: contents;
    font-weight: 600;
  }
  div {
    display: flex;
    gap: 8px;
    width: 100%;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    width: 450px;
    div {
      max-width: unset;
    }
  }
`;

const CloseIcon = styled.img`
  cursor: pointer;
  width: 14px;
  height: 14px;
  transform: rotate(90deg);
  transition: all 0.8s ease-out 0s;

  &:hover {
    transform: rotate(360deg);
    transition: all 1s ease-out 0s;
  }
`;

const EditBtnParagraph = styled.p`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #883E89;
`;
const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

const MessageBoxParagraphCss = css`
  font-family: "Open Sans";
  font-style: normal;
  line-height: 180%;
  color: #434343;
  font-size: 14px;
  font-weight: 500;
  @media screen and (max-width: 768px) {
    font-size: 14px;
    font-weight: 400;
  }
`;

const FormContainer = styled.div<FormContainerProps>`
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  transition: all 0.2s ease;
  @media screen and (min-width: 768px) {
    max-width: 588px;
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }
`;
const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom: 24px;
  @media screen and (min-width: 768px) {
    margin-bottom: 48px;
  }
`;
const FormContentContainer = styled.div`
  display: block;
  flex-wrap: wrap;
  column-gap: 30px;
  flex-direction: column;
  justify-content: space-evenly;
  margin: auto;
  @media screen and (min-width: 769px) {
    flex-direction: row;
    justify-content: center;
    max-width: 588px;
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }
`;
const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  margin: 0 ${(props) => props.marginHorizontal};
  margin-bottom: 16px;
  @media screen and (max-width: 768px) {
    padding: 0 20px;
    margin: 0 20px 16px 20px;
  }
`;

const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    margin: 0;
    padding: 0;
  }
`;

const FormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 80px;
  margin-bottom: 100px;
  column-gap: 40px;
  padding: 0 24px;
  @media screen and (max-width: 768px) {
    column-gap: 0;
    row-gap: 10px;
    margin-top: 40px;
    flex-direction: column;
    align-items: center;
  }
  @media screen and (min-width: 769px) {
    width: 100%;
  }
`;

const HeaderDescriptionCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 160%;
  text-align: center;
  color: #8a8988;
  @media screen and (max-width: 768px) {
    font-weight: 400;
    max-width: 300px;
    margin: auto;
  }
`;

const container_with_bg_css = css`
  margin: 24px 0 0 0;
  &nth-child(1) {
    margin: 64px 0 0 0;
  }
`;
const title_with_bg_css = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  font-size: 18px;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size: 18px;
  }
`;

export interface FormContainerProps {
  margin?: string;
  maxWidth?: string;
}
export interface MessageNoteProps {
  color?: string;
}

export interface StepInterface {
  label: string;
  isCurrentStep: boolean;
}
export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}

const modalPadding = css`
  .modal-body {
    padding: 24px 16px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .modal-body {
      padding: 36px;
    }
  }
`;
